var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dialog-notify',{ref:"max-instance-reached",attrs:{"title":_vm.title}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[(_vm.$store.state.api.modelsFlagLoaded.organizationData)?_c('div',[_c('p',{domProps:{"innerHTML":_vm._s(_vm.text)}})]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49ff0782","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Partials/dialog-max-running-instance-reached.vue
// module id = OB3q
// module chunks = 1